import {
  createInvitation,
  deleteInvitation,
  fetchInvitations,
  fetchProfiles,
  setProfileActive,
  updateProfile,
} from "../lib/api.js";
import { formatDate } from "../lib/format.js";
import { confirmDialog, escapeHtml, openModal, showError } from "../lib/ui.js";
import { mountColoniaSwitch } from "./colonia/interruptor.js";

export async function renderPeople(container) {
  container.innerHTML = `<h2>Personas</h2><p>Cargando…</p>`;

  try {
    const [profiles, invitations] = await Promise.all([fetchProfiles(), fetchInvitations()]);
    const pending = invitations.filter((i) => !i.used_at);
    const reload = () => renderPeople(container);

    container.innerHTML = `
      <div id="view">
      <h2>Personas</h2>
      <div class="toolbar">
        <span>${profiles.length} persona(s)</span>
        <button class="btn" id="invite-person">+ Invitar persona</button>
      </div>
      <div class="panel">
        <div class="table-wrap"><table class="table-cards">
          <thead><tr><th>Nombre</th><th>Rol</th><th>Estado</th><th></th></tr></thead>
          <tbody>
            ${profiles
              .map(
                (p) => `<tr class="${p.active ? "" : "row-inactive"}">
                  <td data-label="Nombre">${escapeHtml(p.name)}</td>
                  <td data-label="Rol">
                    <select data-role-for="${escapeHtml(p.id)}"${p.active ? "" : " disabled"}>
                      <option value="admin"${p.role === "admin" ? " selected" : ""}>admin (familia)</option>
                      <option value="empleado"${p.role === "empleado" ? " selected" : ""}>empleado</option>
                      <option value="padres"${p.role === "padres" ? " selected" : ""}>Papá y Mamá</option>
                    </select>
                  </td>
                  <td data-label="Estado">
                    ${
                      p.active
                        ? '<span class="badge" style="background: var(--success)">activa</span>'
                        : '<span class="badge" style="background: var(--text-muted)">dada de baja</span>'
                    }
                  </td>
                  <td data-label="">
                    <div class="row-actions">
                      <button class="icon-btn" data-rename="${escapeHtml(p.id)}" data-name="${escapeHtml(p.name)}">Cambiar nombre</button>
                      <button class="icon-btn ${p.active ? "danger" : ""}"
                              data-toggle-active="${escapeHtml(p.id)}"
                              data-active="${p.active}"
                              data-name="${escapeHtml(p.name)}">
                        ${p.active ? "Dar de baja" : "Reactivar"}
                      </button>
                    </div>
                  </td>
                </tr>`
              )
              .join("")}
          </tbody>
        </table></div>
        <p class="hint">
          Dar de baja corta el acceso al instante y conserva todo lo que la persona cargó.
          Para borrar la cuenta del todo, hacelo en Supabase → Authentication → Users.
        </p>
      </div>

      <div class="panel">
        <h3>Invitaciones pendientes</h3>
        <p class="hint">
          Sólo se puede registrar quien esté en esta lista: la base rechaza cualquier
          alta con un correo que no figure acá.
        </p>
        ${
          pending.length === 0
            ? "<p>No hay invitaciones pendientes.</p>"
            : `<div class="table-wrap"><table class="table-cards">
                <thead><tr><th>Correo</th><th>Nombre</th><th>Rol</th><th>Invitada</th><th></th></tr></thead>
                <tbody>
                  ${pending
                    .map(
                      (i) => `<tr>
                        <td data-label="Correo">${escapeHtml(i.email)}</td>
                        <td data-label="Nombre">${escapeHtml(i.name ?? "—")}</td>
                        <td data-label="Rol">${escapeHtml(i.role)}</td>
                        <td data-label="Invitada">${formatDate(i.created_at.slice(0, 10))}</td>
                        <td data-label="">
                          <button class="icon-btn danger" data-cancel-invite="${escapeHtml(i.email)}">Cancelar</button>
                        </td>
                      </tr>`
                    )
                    .join("")}
                </tbody>
              </table></div>`
        }
      </div>
      </div>
    `;

    const view = container.querySelector("#view");

    view.querySelector("#invite-person").addEventListener("click", () => openInviteModal(reload));

    view.addEventListener("change", async (e) => {
      const profileId = e.target.dataset?.roleFor;
      if (!profileId) return;
      try {
        await updateProfile(profileId, { role: e.target.value });
      } catch (error) {
        window.alert(`No se pudo cambiar el rol: ${error.message}`);
        reload();
      }
    });

    view.addEventListener("click", async (e) => {
      const renameId = e.target.dataset?.rename;
      const toggleId = e.target.dataset?.toggleActive;
      const cancelInvite = e.target.dataset?.cancelInvite;

      if (cancelInvite) {
        if (!confirmDialog(`¿Cancelar la invitación de ${cancelInvite}? No va a poder registrarse.`)) return;
        try {
          await deleteInvitation(cancelInvite);
          reload();
        } catch (error) {
          window.alert(`No se pudo cancelar: ${error.message}`);
        }
        return;
      }

      if (renameId) {
        const name = window.prompt("Nombre de la persona:", e.target.dataset.name);
        if (!name) return;
        try {
          await updateProfile(renameId, { name: name.trim() });
          reload();
        } catch (error) {
          window.alert(`No se pudo cambiar el nombre: ${error.message}`);
        }
        return;
      }

      if (toggleId) {
        const wasActive = e.target.dataset.active === "true";
        const name = e.target.dataset.name;
        const message = wasActive
          ? `¿Dar de baja a ${name}? Pierde el acceso al instante, pero se conserva todo lo que cargó.`
          : `¿Reactivar el acceso de ${name}?`;
        if (!window.confirm(message)) return;

        try {
          await setProfileActive(toggleId, !wasActive);
          reload();
        } catch (error) {
          window.alert(`No se pudo cambiar el estado: ${error.message}`);
        }
      }
    });

    // Interruptor de la Colonia nueva. No se muestra si la base no tiene la 0020.
    mountColoniaSwitch(container).catch(() => {});
  } catch (error) {
    showError(container, error);
  }
}

function openInviteModal(onSaved) {
  const modal = openModal(`
    <button class="modal-close" type="button" data-close>✕</button>
    <h3>Invitar persona</h3>
    <p style="color: var(--text-muted); font-size: 14px; margin-top: 0">
      Se habilita ese correo para registrarse. La persona entra a la app, toca
      “Creá tu cuenta” y define su propia contraseña. Sin invitación, el alta se rechaza.
    </p>
    <form id="invite-form">
      <div class="field">
        <label for="i-name">Nombre</label>
        <input type="text" id="i-name" name="name" required />
      </div>
      <div class="field">
        <label for="i-email">Correo electrónico</label>
        <input type="email" id="i-email" name="email" required />
      </div>
      <div class="field">
        <label for="i-role">Rol</label>
        <select id="i-role" name="role">
          <option value="empleado">empleado</option>
          <option value="admin">admin (familia)</option>
          <option value="padres">Papá y Mamá</option>
        </select>
      </div>
      <p class="error-text" id="invite-error" hidden></p>
      <div class="modal-actions">
        <button type="button" class="btn secondary" data-close>Cancelar</button>
        <button type="submit" class="btn" id="invite-submit">Invitar</button>
      </div>
    </form>
  `);

  modal.querySelectorAll("[data-close]").forEach((btn) => btn.addEventListener("click", () => modal.close()));

  const form = modal.querySelector("#invite-form");
  const errorEl = modal.querySelector("#invite-error");
  const submit = modal.querySelector("#invite-submit");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.hidden = true;
    submit.disabled = true;
    submit.textContent = "Invitando…";
    try {
      await createInvitation({
        email: form.email.value.trim(),
        name: form.name.value.trim(),
        role: form.role.value,
      });
      modal.close();
      onSaved?.();
    } catch (error) {
      errorEl.textContent = error.message.includes("duplicate")
        ? "Ese correo ya estaba invitado."
        : error.message;
      errorEl.hidden = false;
      submit.disabled = false;
      submit.textContent = "Invitar";
    }
  });
}
